import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { createApi } from '@reduxjs/toolkit/query/react';

import fetchBaseQuery from '../fetchBaseQuery';

type BranchErrorResponse = {
    error: {
        code: number;
        message: string;
    };
};

export const isErrorResponse = (
    error: FetchBaseQueryError | SerializedError,
): error is { status: 400; data: BranchErrorResponse } => {
    if (!('status' in error)) {
        return false;
    }

    const data = error.data as BranchErrorResponse;

    return data && data.error && data.error.code >= 400 && data.error.message !== undefined;
};

export type BranchPayload = {
    projectId: string;
    name: string;
};

export const branchApi = createApi({
    reducerPath: 'branchApi',
    baseQuery: fetchBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        createBranch: builder.mutation<unknown, BranchPayload>({
            query: ({ projectId, name }) => ({
                method: 'POST',
                url: `/project-branch/${projectId}`,
                body: {
                    name,
                },
            }),
        }),
    }),
});

export const { useCreateBranchMutation } = branchApi;

export default branchApi;
